(function($) {

	var message = null;
    var yesCallback = null;
    var noCallback = null;
    var yesButtonText = "";
    var noButtonText = "";
    
    if (typeof addButtonText !== "undefined") {
    	yesButtonText = addButtonText;
    	noButtonText = closeButtonText;
    } else {
		$.getScript('js/resourceHelper.js')
			.done(function(script, textStatus) {
				// Give resourceHelper a chance to run
				setTimeout(function() {
					var helper = new ResourceHelper('GeneralResources');
			    	yesButtonText = helper.getValue('yes.text');
			    	noButtonText = helper.getValue('no.text');
				}, 50);
			} );
    }
    
    $.extend({
        showYesNoDialog : function(options) {
            var dialogID = '#yesNoDialog';
            var title = '';
            var width = 400;
            
            
            if (options) {
                if (options.dialogID) {
                    dialogID = options.dialogID;
                }
                
                if (options.title) {
                    title = options.title;
                }
            
                if (options.message) {
                    message = options.message;
                }
                
                if (options.yesButtonText) {
                	addButtonText = options.okButtonText;
                }
                
                if (options.noButtonText) {
                	closebuttonText = options.noButtonText;
                }
                
                width  = (options.width)?  options.width : width;
                //height = (options.height)? options.height: height;
                
                yesCallback = options.yesCallback;
                noCallback = options.noCallback;
            }
            
            $(dialogID).dialog({
                title : title,
                width : width,
                modal : true,
                draggable : false,
                resizable : false,
                classes: {'ui-dialog' : 'cpwr-ui-dialog'},
                buttons : {
                    "OK" : {
                        text : yesButtonText,
                        click : function() {
                            $(this).dialog('close');
                            
                            if (typeof yesCallback === 'function') {
                            	yesCallback.call(this);
                            }
                        }
                    },
	                "CANCEL" : {
	                    text : noButtonText,
	                    click : function() {
	                        $(this).dialog('close');
	                        
	                        if (typeof noCallback === 'function') {
	                        	noCallback.call(this);
	                        }
	                    }
	                }
                },
                open: function() {
                    $(this).html(message ? message : '');
                },
                close: function(event, ui) {
                    $(this).html('');
                }
            });
        }
    });
})(jQuery);
